import {Injectable} from '@angular/core';
import {PagedResponse} from "../models/paged-response";
import {HttpClient} from "@angular/common/http";
import {Observable, Subject} from "rxjs";
import {Booking} from "../models/booking";
import {CrudService} from "./crud.service";

@Injectable({
    providedIn: 'root'
})
export class BookingService extends CrudService<Booking> {
    constructor(http: HttpClient) {
        super(http, 'bookings');
    }

    async cancelBooking(id: string) {
        await this.http.put<any>(`bookings/${id}/cancel`, {}).toPromise();
        this.dataChangedSubject.next(true);
    }

    async getBooking(bookingId: string) {
        return await this.http.get<any>(`bookings/${bookingId}`).toPromise();
    }

    getAllExtra(params: any, driver: string, rider: string) {
        if(driver) params.driver = driver;
        if(rider) params.rider = rider;
        return this.getAll(params);
    }

    async addNote(id: string, note: string) {
        const data = await this.http.put<any>(`bookings/${id}/note`, {note}).toPromise();
        this.dataChangedSubject.next(true);
        return data;
    }
}
